import { colors } from 'components/styles/variables';

export default function ServerError() {
  return (
    <div className="server-error-container">
      We're sorry, but something went wrong.
      <style jsx>{`
        div {
          font-size: 19px;
          font-weight: 900;
          color: ${colors.ALR1};
          width: 100%;
          text-align: center;
          padding: 100px 0;
        }
      `}</style>
    </div>
  );
}
